import { render, staticRenderFns } from "./seat-page.vue?vue&type=template&id=6f0dfb65&scoped=true&"
import script from "./seat-page.vue?vue&type=script&lang=js&"
export * from "./seat-page.vue?vue&type=script&lang=js&"
import style0 from "./seat-page.vue?vue&type=style&index=0&id=6f0dfb65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0dfb65",
  null
  
)

export default component.exports